<template>
  <v-card>
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Project Details</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>

    <v-card-text style="max-height: 85%">
      <div v-if="['sadmin', 'admin', 'accountant'].includes(role)">
        <ProjectAccountsDetails :details="details" />
        <br />
      </div>

      <ProjectAgentDetails :agent="details ? details.agent : {}" title="Agent Details" />
      <br />

      <ProjectCandidateDetails :project="details ? details.project : {}" />
      <br />

      <ProjectMedicalDetails :project="details ? details.project : {}" />
      <br />

      <ProjectCompanyDetails :employer="details ? details.employer : {}" />
      <br />

      <ProjectVisaDetails
        :project="details ? details.project : {}"
        :visa="details ? details.visa : {}"
        :trade="details ? details.trade : {}"
      />
      <br />

      <ProjectBiometricDetails :project="details ? details.project : {}" />
      <br />

      <ProjectBMETDetails :project="details ? details.project : {}" />
      <br />

      <ProjectFlightDetails :project="details ? details.project : {}" />
      <br />

      <div v-if="['sadmin', 'admin', 'accountant'].includes(role)">
        <ProjectPayments
          type="payment"
          :payments="details ? details.payments : []"
          @add="onAddPayment"
          @delete="onPaymentDelete"
        />
        <br />
        <ProjectPayments
          type="receive"
          :payments="details ? details.receives : []"
          @add="onAddReceive"
          @delete="onPaymentDelete"
        />
        <br />
      </div>

      <MdsirFileWidget :ofID="item && item.id" ofName="projects" />
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-btn
        @click="trasferNextStage"
        outline
        round
        :color="trasferText == 'Transferred' ? 'success' : 'warning'"
        small
        v-if="trasferText"
        :disabled="trasferText == 'Transferred'"
        >{{ trasferText }}</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn @click="onCancelled">Close</v-btn>
    </v-card-actions>

    <v-dialog v-model="isPaymentModal" scrollable persistent max-width="600px">
      <ProjectPaymentReceiveForm
        :type="selectedPaymentType"
        :project="item"
        :accountHeadsTV="accountHeadsTV"
        @cancelled="isPaymentModal = false"
        @added="onPaymentAdded"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { GENDERS } from "../../mdsir/const";
import { getTV, removeEmptyProps } from "../../mdsir/MdsirUtils";

import MdsirFileWidget from "../file-widget/MdsirFileWidget";
import ProjectPaymentReceiveForm from "./ProjectPaymentReceiveForm";
import ProjectPayments from "./ProjectPayments";
import ProjectAgentDetails from "./ProjectAgentDetails";
import ProjectCandidateDetails from "./ProjectCandidateDetails";
import ProjectMedicalDetails from "./ProjectMedicalDetails";
import ProjectCompanyDetails from "./ProjectCompanyDetails";
import ProjectVisaDetails from "./ProjectVisaDetails";
import ProjectBiometricDetails from "./ProjectBiometricDetails";
import ProjectBMETDetails from "./ProjectBMETDetails";
import ProjectFlightDetails from "./ProjectFlightDetails";
import ProjectAccountsDetails from "./ProjectAccountsDetails";

export default {
  components: {
    MdsirFileWidget,
    ProjectPaymentReceiveForm,
    ProjectPayments,
    ProjectAgentDetails,
    ProjectCandidateDetails,
    ProjectMedicalDetails,
    ProjectCompanyDetails,
    ProjectVisaDetails,
    ProjectBiometricDetails,
    ProjectBMETDetails,
    ProjectFlightDetails,
    ProjectAccountsDetails,
  },
  props: ["item", "details"],
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        name: "",
        mobile: "",
        email: "",
        notes: "",
        address: "",
      },
      // categories: []
      agentProps: [
        { title: "Name", key: "name" },
        { title: "Mobile", key: "mobile" },
        { title: "Email", key: "email" },
        { title: "Address", key: "address" },
        { title: "Notes", key: "notes" },
      ],

      relatedFiles: [],
      isPaymentModal: false,
      selectedPaymentType: "",
      accountHeads: [],
    };
  },
  computed: {
    accountHeadsTV() {
      return getTV(this.accountHeads, { textField: "title", valueField: "id" });
    },
    trasferText() {
      let text = null;

      const { project } = this.details;

      switch (this.role) {
        case "entry":
          text = project && project.entry_done ? "Transferred" : "Trasfer to Visa/Processing"
          break;
        case "processing":
          text =  project && project.processing_done ? "Transferred" : "Trasfer to Manpower (BMET)"
          break;
        case "manpower":
          text =  project && project.manpower_done ? "Transferred" : "Trasfer to Accounts"
          break;
      }
      return text;
    },
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onPaymentAdded(addedData) {
      this.$emit("paymentAdded", addedData);
    },
    onNewItemAdded(addedData) {
      this.$emit("added", addedData);
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addAgentForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addAgentForm.reset();
    },
    resetValidation() {
      this.$refs.addAgentForm.resetValidation();
    },
    clearForm() {
      this.newItem.name = "";
      this.newItem.mobile = "";
      this.newItem.email = "";
      this.newItem.address = "";
      this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addAgentForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/agent", this.newItem).then((res) => {
          if (res.data.success) {
            this.onNewItemAdded(res.data.data);
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    },
    onAddPayment() {
      this.isPaymentModal = true;
      this.selectedPaymentType = "payment";
      this.get("/account_heads").then((response) => {
        this.accountHeads = response.data.data;
      });
    },
    onAddReceive() {
      this.isPaymentModal = true;
      this.selectedPaymentType = "receive";
    },
    async onPaymentDelete(payment) {
      const res = await this.$http.delete(`/project_payment/${payment.id}`);
      this.snackbarShow(res.data);
      if (res.data.success) {
        this.$emit("reload");
      }
    },
    async trasferNextStage() {
      const {
        project: { id },
      } = this.details;

      const res = await this.put(`/project_stage_done/${id}`);
      this.snackbarShow(res.data);
      if (res.data.success) {
        this.$emit("reload");
      }
    },
  },
  mounted() {
    // this.loadRelatedFiles();
  },

  beforeDestroy() {},

  created() {
    this.GENDERS = GENDERS;
  },
};
</script>

<style>
.table-r {
  border-collapse: collapse;
  width: 100%;
  margin: 10px 0 10px 0;
}

.table-r td,
.table-r th {
  border-bottom: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.table-r tr:nth-child(1) {
  background-color: #dddddd;
}
</style>
